import { FOLLOW_PROCESSING_END } from 'root/src/client/logic/creatorData/actionIds'
import { apiStoreLenses } from 'root/src/client/logic/api/lenses'

const { setFollowProcessing } = apiStoreLenses

export default {
	[FOLLOW_PROCESSING_END]: setFollowProcessing(false),
}
